import { render, staticRenderFns } from "./TipoDispositivoPantalla.vue?vue&type=template&id=7d76cb50&"
import script from "./TipoDispositivoPantalla.vue?vue&type=script&lang=ts&"
export * from "./TipoDispositivoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports